export type PlatformAppId =
  "auth" | "learners" | "parents" | "instructors" | "proctors" | "organizations" | "institutions";

export const APP_ID: PlatformAppId = "auth";

const readEnvironment = (key: string, fallback: string) => {
  const value = import.meta.env[key];
  return typeof value === "string" && value.trim() ? value.replace(/\/$/, "") : fallback;
};

export const platformEnvironment = Object.freeze({
  apiBaseUrl: readEnvironment("VITE_ACADEMY_API_BASE_URL", "https://api.academy.chatoner.com"),
  classOrigin: readEnvironment("VITE_CLASS_ORIGIN", "https://class.chatoner.com"),
  labsOrigin: readEnvironment("VITE_LABS_ORIGIN", "https://labs.chatoner.com"),
  appOrigins: Object.freeze({
    auth: readEnvironment("VITE_ACADEMY_ACCESS_URL", "https://academy.chatoner.com/auth"),
    learners: readEnvironment("VITE_LEARNERS_ORIGIN", "https://learners.academy.chatoner.com"),
    parents: readEnvironment("VITE_PARENTS_ORIGIN", "https://parent.academy.chatoner.com"),
    instructors: readEnvironment("VITE_INSTRUCTORS_ORIGIN", "https://instructors.academy.chatoner.com"),
    proctors: readEnvironment("VITE_PROCTORS_ORIGIN", "https://proctors.academy.chatoner.com"),
    organizations: readEnvironment("VITE_ORGANIZATIONS_ORIGIN", "https://organizations.academy.chatoner.com"),
    institutions: readEnvironment("VITE_INSTITUTIONS_ORIGIN", "https://institutions.academy.chatoner.com"),
  }),
});

const localPorts: Record<PlatformAppId, number> = {
  auth: 5173,
  learners: 5174,
  parents: 5175,
  instructors: 5176,
  proctors: 5177,
  organizations: 5178,
  institutions: 5179,
};

export function appBaseUrl(app: PlatformAppId) {
  if (
    import.meta.env.DEV &&
    typeof window !== "undefined" &&
    /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)
  )
    return `${window.location.protocol}//${window.location.hostname}:${localPorts[app]}${
      app === "auth" ? "/auth" : ""
    }`;
  return platformEnvironment.appOrigins[app];
}

export function appOrigin(app: PlatformAppId) {
  return new URL(appBaseUrl(app)).origin;
}

export function appUrl(app: PlatformAppId, path = "") {
  const normalizedPath = path.replace(/^\/+/, "");
  const baseUrl = appBaseUrl(app);
  return normalizedPath ? new URL(normalizedPath, `${baseUrl}/`).toString() : baseUrl;
}
